import Model  from '@/util/models';
import Kompetisi from './Kompetisi';

export default class User extends Model { 
    backend = '/frc/saksi/'; 
    
    childRoles(){
        return this.api.get(this.backend + 'child-roles');
    }
    
    childTingkats(){
        return this.api.get(this.backend + 'child-tingkats');
    }
    
    test(){
        return this.api.get(this.backend + 'test');
    }
    
    profile(){
        return this.api.get(this.backend + 'profile');
    }
    
    updateProfile(body){
        return this.api.post(this.backend + 'profile-update', body);
    }
    
    indexAll(params){
        return this.api.get(this.backend + 'index-page', params).then(res => {          
          return res.status == 200 ? res.data : [];
        });
    }
    
    view(params){                        
        return this.api.post(this.backend + 'view', {}, params); 
    }  
    
    assign(items, params){                        
        return this.api.post(this.backend + 'assign', items, params); 
    }    
    
    remove(items, params){                        
        return this.api.post(this.backend + 'revoke', items, params); 
    } 
    
    setDefaultBranch(data){                        
        return this.api.post(this.backend + 'set-default', data); 
    } 
    
    setavatar(formdata){
        return this.api.post(this.backend + 'setavatar', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    getavatar(params){
        return this.api.get(this.backend + 'getavatar', params); 
    }        
    
    getcover(params){
        return this.api.get(this.backend + 'getcover', params); 
    }
    
    recode(params){
        return this.api.get(this.backend + 'recode', params); 
    }
    
    getavatarThumb(params){
        return this.api.get(this.backend + 'getavatar-thumb', params); 
    }
    
    kompetisis(params){
        return this.api.get(this.backend + 'kompetisis').then(res => {
            return res.status === 200 ? res.data : [];
        })
    }
    
    tingkats(){       
        return this.api.get(this.backend + 'tingkats').then(res => {
            return res.status === 200 ? res.data : [];
        })
    }  
    
    areas(params){
        return this.api.get(this.backend + 'areas',params).then(res => {
            return res.status === 200 ? res.data : [];
        })
    }
}

